import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { delay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-button-footer-list-view',
  templateUrl: './button-footer-list-view.component.html'
})
export class ButtonFooterListViewComponent implements OnInit {
  @Input() constants: any;
  @Input() list: Array<any> = [];
  @Input() self: any;
  @Input() selection: Array<any> = [];
  @Input() data: Array<any> = [];
  @Input() service: any;

  @Output() reload = new EventEmitter();
  @Output() edit = new EventEmitter();

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {}

  add() {
    this.edit.emit();
  }

  delete() {
    const selected = this.selection,
      selectedLength = this.selection.length,
      dataLength = this.data.length;

    let message = '';
    let dialog: any;

    message = this.generalsService.messageSelectedDelete(
      'confirm',
      selectedLength,
      dataLength
    );

    dialog = this.generalsService.alert(message);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result === 200) {
          this.generalsService.delete(
            selected,
            selectedLength,
            dataLength,
            this.service
          );
          this.generalsService.delete$
            .pipe(
              takeUntil(this.constants.destroy$),
              delay(10)
            )
            .subscribe(deleteResult => {
              if (deleteResult) {
                this.reload.emit();
              }
            });
        }
      });
  }
}
